import { Box } from '@pocketlaw/tetris';
import { ApprovalCheckError } from './ApprovalCheckError';
import { useApprovalCheck } from './ApprovalCheckProvider';
import { EvaluatingState } from './EvaluatingState';
import { InitialState } from './InitialState';
import { ReviewState } from './ReviewState';
import { WorkflowInitialState } from './WorkflowInitialState';
export function RequestVoluntaryAdvanced(props) {
    const { runWithWorkflows = false } = props;
    const { startCheck, startCheckWithWorkflow, state } = useApprovalCheck();
    const handleSelectPrompt = (promptId) => {
        startCheck(promptId);
    };
    const handleSelectWorkflow = (workflowId) => {
        startCheckWithWorkflow(workflowId);
    };
    if (state === 'done') {
        return <ReviewState />;
    }
    return (<Box flexDirection="column" p="xl" height="100%">
      <ApprovalCheckError />

      {state === 'initial' &&
            (runWithWorkflows ? (<WorkflowInitialState onSelectWorkflow={handleSelectWorkflow}/>) : (<InitialState onSelectPrompt={handleSelectPrompt}/>))}

      {state === 'evaluating' && <EvaluatingState />}
    </Box>);
}
